import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Directive } from '@angular/core';
import * as i1 from '@odx/angular';
import { WithDisabledState, WithTabIndex } from '@odx/angular';
import { CSSComponent } from '@odx/angular/internal';
import { injectElement } from '@odx/angular/utils';

/**
 * Represents a link directive.
 */
let LinkDirective = class LinkDirective {
    constructor() {
        this.element = injectElement();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LinkDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: LinkDirective, isStandalone: true, selector: "a[odxLink]", hostDirectives: [{ directive: i1.WithDisabledState }, { directive: i1.WithTabIndex }], ngImport: i0 }); }
};
LinkDirective = __decorate([
    CSSComponent('link')
], LinkDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: LinkDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'a[odxLink]',
                    standalone: true,
                    hostDirectives: [WithDisabledState, WithTabIndex],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LinkDirective };
